export const environment = {
  production: window['__env']['production'],
  backendApiUrl: window['__env']['backendApiUrl'],
  optionalBackendApiUrl: window['__env']['optionalBackendApiUrl'],
  expressBackendApiUrl: window['__env']['expressBackendApiUrl'],
  azureAccountUrl: window['__env']['azureAccountUrl'],
  azurePubSubUrl: window['__env']['azurePubSubUrl'],
  nodeApiUrl: 'https://aks-wbe-dev.hospitalityrevolution.com/node/nodeapi',
  captchaSiteKey: window['__env']['captchaSiteKey'],
  showLogs: window['__env']['showLogs'],
  proxy: window['__env']['proxy'],
  gigyaCdnKey: window['__env']['gigyaCdnKey'],
  GaAgilysysId: window['__env']['GaAgilysysId'],
  deploymentType: window['__env']['deploymentType'],
  cloudUrl: window['__env']['cloudUrl'],
  multiLanguageSupport: window['__env']['multiLanguageSupport'],
  isAzureB2CAuthenticationEnabled: window['__env']['isAzureB2CAuthenticationEnabled'],
  deployedEnvironment: window['__env']['deployedEnvironment'],
  adminPortalRedirectDomain: window['__env']['adminPortalRedirectDomain'],
  adminPortalExpressRedirectDomain: window['__env']['adminPortalExpressRedirectDomain'],
  spendUiUrl: window['__env']['spendUiUrl'],
};
